import { gql } from "@apollo/client";

export const updatesimform = gql`
mutation da_simform_publish2s(
      $sfrid: uuid
      $published: Boolean
      $preview:Boolean
      $knowledge:String
      $skil:String
      $attitude:String
      $app:Int
      $tkn:Int
      $fpa:Int
      $fpm:Int
      $com:Int
      $ltw:Int
      $pdm:Int
      $saw:Int
      $wlm:Int
      $cal:Int
      $remarkstext:String
      $resulttext:String
      $traineesign:String
      $trainersign:String
      $timestamp:timestamptz
      ) 
      {
        update_aatmsv4_simformrecords(_set: 
          {
            active: true,
            published: $published,
            preview: $preview,
            knowledge:$knowledge,
            skil:$skil,
            attitude:$attitude,
            app:$app,
            tkn:$tkn,
            fpa:$fpa,
            fpm:$fpm,
            com:$com,
            ltw:$ltw,
            pdm:$pdm,
            saw:$saw,
            wlm:$wlm,
            cal:$cal,
            remarkstext:$remarkstext,
            resulttext:$resulttext,
            traineesign:$traineesign,
            trainersign:$trainersign,
            timestamp:$timestamp
          },
          where: {sfrid: {_eq: $sfrid}}) 
          {
          returning {
          sfrid
          }
      }
    }
`;
export const simformQueryList = gql`
query S_SimFormData_List( $trainerid: String) {
  aatmsv4_simformrecords(order_by: {date: asc}, where: {active: {_eq: true},published: {_eq: false},trainerid: {_eq: $trainerid }}) {
    sfrid
    active
    app
    attitude
    cal
    category
    clentsid
    clientname
    com
    date
    fleetsid
    fpa
    fpm
    knowledge
    ltw
    minutes
    ntc
    pdm
    preview
    published
    reginfo
    remarks
    remarkstext
    result
    resulttext
    saw
    sid
    simformid
    simformname
    simlocation
    simrecord
    simtype
    simreg
    stage
    skil
    subcategory
    tc
    tkn
    traineeecode
    traineeid
    traineelicence
    traineename
    traineerank
    traineerankid
    traineesign
    trainerecode
    trainerid
    trainerlicense
    trainername
    trainerrank
    trainerrankid
    trainersign
    validity
    validtill
    wlm
    timestamp
    stcrecords {
      sfrid
      stcrid
      active
      ata
      clientname
      clientsid
      fleetsid
      null
      patch
      phase
      published
      score
      sequence
      simformid
      sits
      stcid
      stcname
      stcshortname
      traineeid
      trainerid
      }
    }
  }
  
`
export const headerMutation = gql`
mutation s_simform_conduct_new(
  $date: date  
  $sid: uuid  
  $simlocation: String
  $simreg: String
  $simtype: String
  $clientid: uuid
  $clientname: String
  $fleetid: uuid
  $simformid: uuid
  $simformname: String
  $minutes: Int
  $category:aatmsv4_category_enum
  $subcategory: aatmsv4_subcategory_enum
  $tc: Boolean
  $ntc: Boolean
  $remarks: Boolean
  $result: Boolean
  $reginfo: String
  $validity: Int
  $validtill:date
  $traineeid: String
  $traineeecode: String  
  $traineename: String
  $traineerank: String
  $traineerankid: uuid
  $traineelicence: String
  $trainerid: String
  $trainerecode: String
  $trainername: String
  $trainerlicense: String
  $trainerrank: String
  $trainerrankid: uuid
  $manageremail:String
  $trainersign:String
  $timestamp: timestamptz 
  $cal:Int
  $wlm:Int
  $com:Int
  $tkn:Int
  $app:Int
  $pdm:Int
  $fpa:Int
  $fpm:Int 
  $ltw:Int
  $saw:Int
  $skil: String
  $attitude: String
  $knowledge: String
) {
  insert_aatmsv4_simformrecords(objects: {
    active: true
    category: $category
    preview: true
    published: false
    stage: 2
    date: $date
    sid: $sid
    simlocation: $simlocation
    simreg: $simreg
    simtype: $simtype
    traineeid: $traineeid
    traineeecode: $traineeecode
    traineelicence: $traineelicence
    traineename: $traineename
    traineerank: $traineerank
    traineerankid: $traineerankid
    trainerid: $trainerid
    trainerecode: $trainerecode
    trainerlicense: $trainerlicense
    trainername: $trainername
    trainerrank: $trainerrank
    trainerrankid: $trainerrankid
    trainersign:$trainersign
    clentsid: $clientid
    clientname: $clientname
    minutes: $minutes
    subcategory: $subcategory
    simformname: $simformname
    tc: $tc
    ntc: $ntc
    remarks: $remarks
    result: $result
    reginfo: $reginfo
    validity: $validity
    simformid: $simformid
    fleetsid: $fleetid 
    validtill: $validtill
    manageremail: $manageremail
    timestamp: $timestamp
    wlm: $wlm
    com: $com
    tkn: $tkn
    skil: $skil
    app: $app
    attitude: $attitude
    cal: $cal
    pdm: $pdm
    saw:$saw
    fpa: $fpa
    fpm: $fpm
    knowledge: $knowledge
    ltw: $ltw
  }) {
  returning {
    sfrid
    active
    app
    attitude
    cal
    category
    clentsid
    clientname
    com
    date
    fleetsid
    fpa
    fpm
    knowledge
    ltw
    minutes
    ntc
    pdm
    preview
    published
    reginfo
    remarks
    remarkstext
    result
    resulttext
    saw
    sid
    simformid
    simformname
    simlocation
    simrecord
    simtype
    simreg
    stage
    skil
    subcategory
    tc
    tkn
    traineeecode
    traineeid
    traineelicence
    traineename
    traineerank
    traineerankid
    traineesign
    trainerecode
    trainerid
    trainerlicense
    trainername
    trainerrank
    trainerrankid
    trainersign
    validity
    validtill
    wlm 
    stcrecords {
      sfrid
      stcrid
      active
      ata
      clientname
      clientsid
      fleetsid
      null
      patch
      phase
      published
      score
      sequence
      simformid
      sits
      stcid
      stcname
      stcshortname
      traineeid
      trainerid
      }
  }
  }
  } 
`
export const checkSimFormPublished = gql`query s_form_resume_preview(
  $sfrid: uuid
) {
  aatmsv4_simformrecords(where: {sfrid: {_eq: $sfrid}, published: {_eq: true}}) {
    sfrid
  }
 }
 `;
export const graphsimform = gql`
 query MyQuery (
   $crewid:String
   $start:date
   $end:date
 ) {
   aatmsv4_crews(where: {crewid: {_eq: $crewid}}) {
     client {
       logo
       clientname
     }
     fleet {
       aircraft
       trainingmanagers
     }
     rank {
       rank
     }
     name
     atcrecords(order_by: {date: asc}, where: {published: {_eq: true}, traineeid: {_eq: $crewid}}) {
       date
       patch
       score
       sits
     }
     airformrecords(order_by: {date: asc}, where: {traineeid: {_eq: $crewid}, published: {_eq: true}}) {
       cal
       app
       tkn
       fpa
       fpm
       com
       ltw
       pdm
       saw
       wlm
       date
     }
     simformrecords(order_by: {date: asc}, where: {traineeid: {_eq: $crewid}, published: {_eq: true}}) {
       cal
       app
       tkn
       fpa
       fpm
       com
       ltw
       pdm
       saw
       wlm
     }
     photo
     stcrecords(order_by: {date: asc}, where: {published: {_eq: true}, traineeid: {_eq: $crewid }}) {
       date
       patch
       score
       sits
     }
     email
   }
 }`;
export const submitstcform = gql`
      mutation da_stcrecordss_pub(
        $ata:Int
        $sits:Int
        $score:Int
        $patch:String
        $published:Boolean
        $sfrid:uuid
        $stcrid:uuid
      ) {
        update_aatmsv4_stcrecords(_set: 
          { 
            ata:$ata,
            sits:$sits,
            score:$score,
            patch:$patch
            active:true,
            published:$published             
          },
          where: {sfrid: {_eq: $sfrid}, stcrid:{_eq:$stcrid}}) {
        returning {
         stcrid
        }
      }
    }`
export const SaveUrlSimForm = gql`
    mutation da_simformURL_publish2(
          $sfrid: uuid
          $stcrecord: String
          ) {
            update_aatmsv4_simformrecords(_set: 
              {
                simrecord: $stcrecord,
              },
              where: {sfrid: {_eq: $sfrid}}) {
            returning {
             sfrid
            }
          }
        }
    `;
export const submitsimform = gql`
mutation da_simform_publish2(
      $sfrid: uuid
      $published: Boolean
      $preview:Boolean
      $knowledge:String
      $skil:String
      $attitude:String
      $app:Int
      $tkn:Int
      $fpa:Int
      $fpm:Int
      $com:Int
      $ltw:Int
      $pdm:Int
      $saw:Int
      $wlm:Int
      $cal:Int
      $remarkstext:String
      $resulttext:String
      $traineesign:String
      $trainersign:String
      ) {
        update_aatmsv4_simformrecords(_set: 
          {
            active: true,
            published: $published,
            preview: $preview,
            knowledge:$knowledge,
            skil:$skil,
            attitude:$attitude,
            app:$app,
            tkn:$tkn,
            fpa:$fpa,
            fpm:$fpm,
            com:$com,
            ltw:$ltw,
            pdm:$pdm,
            saw:$saw,
            wlm:$wlm,
            cal:$cal,
            remarkstext:$remarkstext,
            resulttext:$resulttext,
            traineesign:$traineesign,
            trainersign:$trainersign,
          },
          where: {sfrid: {_eq: $sfrid}}) {
        returning {
         sfrid
        }
      }
    }
`;
export const simformpreview = gql`query s_conduct_resume_preview(
  $sfrid: uuid
  $preview:Boolean
  $published:Boolean
) {
  aatmsv4_simformrecords(where: {sfrid: {_eq: $sfrid}, active: {_eq: true}, preview: {_eq: $preview}, published: {_eq: $published}}) {
  client {
  logo
  clientname
  department
  headerrh1
  headerrh2
  headerrh3
  }
  traineeecode
  sfrid
  ntc
  tc
  remarks
  result
  resulttext
  simformname
  date
  minutes
  fleet {
  aircraft
  }
  simtype
  simlocation
  simreg
  trainerecode
  trainerrank
  trainername
  trainerlicense
  traineeecode
  traineerank
  traineename
  traineelicence
  knowledge
  skil
  attitude
  app
  tkn
  fpa
  fpm
  com
  ltw
  pdm
  saw
  wlm
  cal
  remarkstext
  traineesign
  trainersign
  reginfo
  stcrecords(where: {sfrid: {_eq: $sfrid}, active: {_eq: true}}, order_by: {sequence: asc}) {
  sequence
  phase
  stcname
  sits
  score
  patch
  }
  manageremail
  preview
  published
  }
 }
 `;
export const stcformpreview = gql`query s_conduct_resume_preview(
  $sfrid: uuid
) {
  aatmsv4_stcrecords(where: {sfrid: {_eq: $sfrid}, active: {_eq: true}}, order_by: {sequence: asc}) {
  stcrecords
  sequence
  phase
  stcname
  sits
  score
  patch 
  }
 }
 `;
export const deleteformpreview = gql`
  mutation MyMutatideleteon (
    $sfrid:uuid
  ) {
    delete_aatmsv4_stcrecords(where: {sfrid: {_eq: $sfrid}}) {
      returning {
      stcshortname
      }
    }
    delete_aatmsv4_simformrecords(where: {sfrid: {_eq: $sfrid}}) {
    returning {
    simformname
    }
    }
   
   }
 `;
export const Register = gql`
query MyQuery($id: String) {
  aatmsv4_register(where: {userid: {_eq: $id}}) {
    fleetsid
    emailofficial
    clientsid
    client {
      clientname
    }
    fleet {
      aircraft
    }
    ecode
    licence
    rank {
      rank
      ranksid
    }
    name
  }
}
`

export const Sim_location_type = gql`
query S_SimForms_Conduct_Sim_dropdown(
    $fleetid: uuid
    $id: uuid
) {
    aatmsv4_sims(order_by: {simlocation: asc}, where: {active: {_eq: true}, clientsid: {_eq: $id}, fleetsid: {_eq: $fleetid}}) {
    simtype
    simlocation
    simreg
    sid
    }  
}
`
export const Sim_type = gql`
query MyQuerysss(
  $id: uuid
) {
  aatmsv4_sims(where: {sid: {_eq: $id}}) {
    simreg
    simtype
    simlocation
  }
}
`
export const Sim_type_location = gql`
  query S_SimForms_Conduct_Sim_dropdown(
  $clientsid:uuid,
  $fleetsid:uuid
  ) {
  aatmsv4_sims(order_by: {simlocation: asc}, where: {active: {_eq: true}, clientsid: {_eq: $clientsid}, fleetsid: {_eq: $fleetsid}}) {
  simtype
  simlocation
  simreg
  sid } 
} 
`
export const simulator_form_dropdown = gql`
query S_SimForm_Conduct_Forms_Dropdown(
  $id: String
) {
  aatmsv4_smap(order_by: {simformname: asc}, where: {active: {_eq: true}, siminstructorid: {_eq:$id}}) {
  simformid 
  simformname
} 
}
`
export const traineeDropdown = gql`
query s_simform_conduct_new_trainee_dropdown(
  $id: uuid
  $fleetid: uuid
) {
  aatmsv4_crews(order_by: {name: asc}, where: {
    clienstid: {_eq: $id}, 
    active: {_eq: true}, fleetsid: {_eq: $fleetid}}) {
  name
  crewid 
  ecode
  email
  rank {
  ranksid
  rank 
}
  license 
} 
}
`
// crewid is a trainee id
export const traineeSelect = gql`
query MyQuery(
  $id: String
) {
  aatmsv4_crews(where: {crewid: {_eq: $id}}) {
    rank {
      rank
      ranksid
    }
    license
  }
}
`
export const simformQuery = gql`
query s_simform_conduct_new(
  $id:uuid
) {
  aatmsv4_simforms(where: {simformid: {_eq: $id}}) {
  simformid
  clientsid
  clientname
  minutes
  category
  subcategory
  cost
  simformname
  tc
  ntc
  remarks
  result
  reginfo
  manageremail
  validity
  stcmaps(order_by: {phaseByPhase: {sequence: asc}, sequence: asc}, where: {simformid: {_eq: $id }})
{
sequence
phase
stcname
stcid
ata
stcshortname }
  }
}
`

export const getTrainerSign = gql`
query MyQuery2TrainerSign(
  $id: String
) {
  aatmsv4_simulatorinst(where: {usersid: {_eq: $id}}) {
  instructorsign
  examinersign
  }
 }
`
export const stcmapQuery = gql`
query MyQuery2(
  $id: uuid
) {
  aatmsv4_stcmap(order_by: {phaseByPhase: {sequence: asc}, sequence: asc}, where: {simformid: {_eq: $id}}) {
    sequence
    phase
    stcname
    stcid
    ata
    stcshortname
  }
}
`
export const stcinerstMutation = gql`
mutation MyMutation_stcreods (
    $ata:Int
    $clientname:String
    $clientsid:uuid
    $fleetsid:uuid
    $phase:aatmsv4_phase_enum
    $sequence:Int
    $sfrid:uuid
    $simformid:uuid
    $stcid:uuid
    $stcname:String
    $stcshortname:String
    $traineeid:String
    $trainerid:String
    $patch:String
    $score:Int
    $sits:Int
    $date:date
) {
  insert_aatmsv4_stcrecords(objects: {
    active:false    
    published:false
    null:false
    ata:$ata 
    clientname:$clientname
    clientsid:$clientsid
    fleetsid:$fleetsid
    phase:$phase
    sequence:$sequence
    sfrid:$sfrid
    simformid:$simformid
    stcid:$stcid
    stcname:$stcname
    stcshortname:$stcshortname
    traineeid:$traineeid
    trainerid:$trainerid
    patch:$patch
    score:$score
    sits:$sits
    date:$date
  }) {
    returning {
      sfrid
      stcrid
      active
      ata
      clientname
      clientsid
      fleetsid
      null
      patch
      phase
      published
      score
      sequence
      simformid
      sits
      stcid
      stcname
      stcshortname
      traineeid
      trainerid
    }
  }
}
`;
export const stcMutation = gql`
mutation S_SimForms_Complete_Tc_Fill(
  $ata: Int
  $clientname: String
  $clientsid: uuid
  $fleetsid: uuid
  $null: Boolean
  $phase: aatmsv4_phase_enum
  $score: Int
  $sequence: Int
  $simformid: uuid
  $sits: Int
  $stcid: uuid
  $stcname: String
  $stcshortname: String
  $sfrid: uuid
) {
  insert_aatmsv4_stcrecords(
    objects: {
    active: false,
    ata: $ata, 
    clientname: $clientname, 
    clientsid: $clientsid,
    fleetsid: $fleetsid,
    null: $null,
    phase: $phase,
    published: false,
    score: $score,
    sequence: $sequence,
    simformid: $simformid,
    sits: $sits,
    stcid: $stcid,
    stcname: $stcname,
    stcshortname: $stcshortname,
    traineeid:"36iIF0G2utduysoUbyjNj7z79pL2",
    trainerid: "5arA1M7KPrRGCvdaWfRxOEsvB6B3",
    sfrid: $sfrid
  }) {
  returning {
  score
  traineeid
  trainerid
  }
  }
  }
`
export const stcrecord = gql`
mutation MyMutation($objects: [aatmsv4_stcrecords_insert_input!]!) {
  insert_aatmsv4_stcrecords(objects: $objects) {
    returning {
      sfrid
      stcrid
    }
  }
}
`
export const stcrecord_data = gql`
query MyQuery($id: uuid) {
  aatmsv4_stcrecords(where: {sfrid: {_eq: $id}}) {
    ata
    phase
    score
    sequence
    sfrid
    simformid
    sits
    stcid
    stcname
    stcrid
    stcshortname
  }
}

`
export const updateStcrecord = gql`
mutation MyMutation(
  $id: uuid
  $score: Int
  $sits: Int
  $null: Boolean
  $patch: String
) {
  update_aatmsv4_stcrecords(where: {stcrid: {_eq: $id}}, _set: {score: $score, sits: $sits, null: $null,patch: $patch}) {
    returning {
      stcname
      stcshortname
    }
  }
}
`
export const updatesimformrecord = gql`
mutation MyMutation(
  $knowledge: String
  $attitude: String
  $skil: String
  $app: Int
  $com: Int
  $fpa: Int
  $fpm: Int
  $ltw: Int
  $pdm: Int
  $tkn: Int
  $wlm: Int
  $saw: Int
  $remarkstext: String
  $resulttext: String
  $sfrid: uuid
  $cal : Int
) {
  update_aatmsv4_simformrecords(where: {sfrid: {_eq: $sfrid}},
   _set: {active: true, app: $app, com: $com, fpa: $fpa, fpm: $fpm, ltw: $ltw, pdm: $pdm, preview: false, published: true, remarkstext: $remarkstext,cal: $cal, resulttext: $resulttext, tkn: $tkn,
    wlm: $wlm, saw: $saw, knowledge: $knowledge, skil: $skil, attitude: $attitude}) {
    returning {
      app
    }
  }
}
`
export const patch = gql`
query MyQuery {
  aatmsv4_patch {
    patchid
    sequence
  }
}
`
export const discard = gql`
mutation MyMutation(
  $id: uuid
) {
  delete_aatmsv4_simformrecords(where: {sfrid: {_eq: $id}}) {
    returning {
      sfrid
    }
  }
}
`
export const discardstc_record = gql`
mutation MyMutation(
  $id: uuid
) {
  delete_aatmsv4_stcrecords(where: {sfrid: {_eq: $id}}) {
    returning {
      stcid
    }
  }
}
`
